import { VenueRequestFile, VenueRequestComment } from './groupBooking';
import { WithId } from './typeUtils';
import { BrandGroupType } from './brand';
import { GO_ORIGIN } from './zod/origin';

export type GroupPartyComments = Omit<VenueRequestComment, 'status'> & { _id: string };

export type GroupPartyOrigin = typeof GO_ORIGIN | (string & {});

export const GROUP_PARTY_FIELD_NAMES = [
  'groupId',
  'groupType',
  'contact',
  'size',
  'groupGuideName',
  'groupGuideCabin',
  'bookingNo',
  'salesOffice',
  'agencyContactName',
  'salesEmail',
  'salesPhone',
  'embark',
  'debark',
  'cabinDrops',
  'diningPreference',
  'prepaidPackages',
  'guestExperience',
  'notes',
  'hospitalityDesk',
  'balanceDue',
  'paymentStatus',
] as const;

export interface NewGroupParty {
  origin?: GroupPartyOrigin;
  name: string;
  contact: string;
  phone?: string;
  email?: string;
  notes: string;
  groupId?: string;
  groupGuideName?: string;
  groupGuideCabin?: string;
  size?: number; // number of guests in party
  groupType?: BrandGroupType;
  hospitalityDesk?: boolean;
  cabinDrops?: string;
  diningPreference?: string;
  guestExperience?: string;
  prepaidPackages?: string;
  embark?: string;
  debark?: string;
  files: VenueRequestFile[];
  bookingNo: string;
  internalNotes: string;
  salesEmail: string;
  salesPhone: string;
  paymentStatus: string;
  balanceDue: string;
  agencyContactName: string;
  comments: GroupPartyComments[];
}

export type GroupParty = NewGroupParty & WithId;
